const DateHelper = {
  isValidBrazilianDate: (date) => {
    const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/;
    return dateRegex.test(date);
  },

  isValidDate: (date) => new Date(date) !== 'Invalid Date' && !Number.isNaN(new Date(date)),

  dateToDisplay: (date) => {
    date = date && date.length > 0 ? (date + '--').split('-') : date;
    return date && date.length > 0 ? date[2] + '/' + date[1] + '/' + date[0] : date;
  },

  displayToDate: (date) => {
    if (DateHelper.isValidBrazilianDate(date)) {
      date = date && date.length > 0 ? (date + '//').split('/') : date;
      return date && date.length > 0 ? date[2] + '-' + date[1] + '-' + date[0] : date;
    }
    return '';
  },

  getFormattedDate: (date) => {
    const fullDate = date !== '' && date.includes('T') ? date : date + 'T00:00:00';
    const dt = new Date(fullDate);
    const day = dt.getDate().toString().padStart(2, '0');
    const month = (dt.getMonth() + 1).toString().padStart(2, '0');
    const year = dt.getFullYear();

    return day + '/' + month + '/' + year;
  },

  dateDifference: (date1, date2) => {
    const timeDiff = date1.getTime() - date2.getTime();

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
    const seconds = Math.floor((timeDiff / 1000) % 60);

    return {
      timeDiff,
      days,
      hours,
      minutes,
      seconds,
    };
  },
};

export default DateHelper;
